<script setup lang="ts">
import { ref } from 'vue'
import { Permission } from '../../../../types/auth'
import ListTemplate from '../../../../components/ui/common/ListTemplate.vue'
import { FilterField, TableField } from '../../../../components/table/table'
import CostingSheetsForm from './CostingSheetsForm.vue'

const endPoint = '/clients/procurement/purchases/costing-sheets/'
const title = 'Costing Sheets'
const selectedData = ref<any | null>(null)
const showForm = ref(false)
const formMode = ref<'create' | 'edit' | 'view' | 'showQuickView' | 'toggleStatus'>('view')
const refreshData = ref(false)

const permissions = ref<Permission[]>();

const fields: TableField[] = [
  { name: 'date_time', caption: 'Date', sortable: true, fieldType: 'date' },
  { name: 'document_no', caption: 'Ref. No', sortable: true, fieldType: 'text'},
  { name: 'vendor', caption: 'Vendor', sortable: true, fieldType: 'text'},
  { name: 'purchase_invoice_no', caption: 'Invoice No', sortable: true, fieldType: 'text' },
  { name: 'status', caption: 'Status', sortable: false, fieldType: 'text' },
]

const filterFields: FilterField[] = [
  {
    name: 'active',
    label: 'Status',
    type: 'select',
    value: '',
    options: [
      { id: '1', name: 'Active' },
      { id: '0', name: 'Inactive' }
    ],
  },
]

const changeMode = (
  mode: "create" | "edit" | "view" | "showQuickView" | "toggleStatus"
) => {
  formMode.value = mode;
  showForm.value = mode === "view" || mode === "edit" || mode === "create";
};

const handleData = (data : any) => {
  selectedData.value = data
}

const listViewRef = ref<InstanceType<typeof ListTemplate> | null>(null);
const viewDocument = (data : any, title: string, path: string) => {
  if (listViewRef.value) {
    listViewRef.value.viewDocument(data, title, path);
  }
}

</script>

<template>
  <ListTemplate ref="listViewRef" :endPoint = "endPoint" :title = "title" :fields = "fields" :actions = "[]" :filterFields ="filterFields"
  :tabList = "[]" :refreshData = "refreshData" @mode="changeMode" @show="showForm = true" :showForm="showForm" 
  @data="handleData">
  <template #form-view>
    <CostingSheetsForm
      v-if="showForm"
      :permissions="permissions"
      :data="selectedData"
      :end-point="endPoint"
      :title="title"
      :mode="formMode"
      @view-document="viewDocument"
      @save="refreshData = !refreshData"
      @close="showForm = !showForm"
    />
  </template>
  </ListTemplate>
</template>